import React, { useEffect, useState } from 'react'
import { Loading } from 'src/components/common/Loading'
import RenderIf from 'src/components/common/RenderIf'
import PurchaseHistorySavePageView from 'src/pages/PurchaseHistoryPage/PurchaseHistorySavePage/view'
import { QueryClient } from '@tanstack/react-query'
import { passCertCheckQueryOption } from 'src/hooks/react-query/useCustomQuery.hook'
import { PassCertResponseSpace, PassReqType, ResponseDataType } from 'src/types/api'
import { v4 } from 'uuid'
import usePassCert from 'src/hooks/usePassCert.hook'
import usePageVisibility from 'src/hooks/usePageVisibility.hook'
import { useChannel } from 'src/provider/ChannelContextProvider'
import { useToast } from 'src/provider/ToastContextProvider'

export interface PurchaseHistorySavePageProps {
  isPassCert: boolean
  passCertRequest: (type: PassReqType) => void
}

export const purchaseHistorySavePageLoader = (queryClient: QueryClient) => async () => {
  const dataQueryValues = [await queryClient.ensureQueryData(passCertCheckQueryOption())]
  return Promise.allSettled(dataQueryValues)
}

const PurchaseHistorySavePage = () => {
  const [uuid, setUuid] = useState(v4())
  const { aos } = useChannel()
  const { openToast } = useToast()
  const { reqNum, passCertRequest, passCertResponse, isPassCert, isPassCertCheckLoading } =
    usePassCert(uuid)

  useEffect(() => {
    if (aos) handlePassCertResponse()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reqNum])

  usePageVisibility((isForeground: boolean) => {
    if (isForeground && !aos) {
      handlePassCertResponse()
    }
  })

  const handlePassCertResponse = () => {
    const successFn = (res: ResponseDataType<PassCertResponseSpace.Response>) => {
      openToast({ contents: '본인 인증이 완료되었습니다.' })
    }
    const failFn = () => setUuid(v4())
    passCertResponse(0, successFn, failFn)
  }

  const props = { isPassCert, passCertRequest }

  return (
    <React.Fragment>
      <RenderIf when={isPassCertCheckLoading}>
        <Loading.Default />
      </RenderIf>
      <PurchaseHistorySavePageView {...props} />
    </React.Fragment>
  )
}
export default PurchaseHistorySavePage
